<template>
    <!-- NOTIFICATIONS -->
    <div class="flex">
        <!-- <vs-button type="border" @click="createMessage()" class="mr-4 mb-2 hidden md:flex" icon-pack="feather" icon="icon-mail">Contact</vs-button> -->

        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <feather-icon icon="MailIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="0"/>

            <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

                <div class="flex justify-between align-center notification-top p-5 bg-primary text-white">
                    <h4 class="text-white">Messagerie</h4>
                    <vx-tooltip text="Créer un nouveau sujet" position="top">
                        <vs-button type="border" color="rgb(255,255,255)" size="small" @click="createSubject()"
                                   icon-pack="feather" icon="icon-plus"></vs-button>
                    </vx-tooltip>
                </div>

                <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10"
                           :settings="settings" :key="$vs.rtl" :class="{'folded': !fullDisplay, 'open': fullDisplay }">
                    <ul class="bordered-items">
                        <li v-for="ntf in notifications" :key="ntf.index" class="p-4 notification cursor-pointer">
                            <div class="flex justify-between items-center mb-1">
                                <div class="flex items-start w-full">
                                    <div class="mr-1 flex flex-col w-full gap-2">
                                        <span class="font-medium block notification-title"
                                              :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
                                        <span v-if="ntf.lastMsg">
                                            <small>{{ ntf.lastMsg.content }}</small>
                                        </span>
                                        <div class="flex justify-content-between align-items-center">
                                            <div v-if=" ntf.status=== 'open'">
                                                Non Lu
                                            </div>
                                            <div v-if=" ntf.status=== 'closed'">
                                                Traité
                                            </div>
                                            <div v-if=" ntf.status=== 'answered'">
                                                Répondu
                                            </div>
                                            <div v-if=" ntf.status=== 'read'">
                                                Lu
                                            </div>
                                            <vs-button @click="$router.push('/messagerie/'+ntf.id)">
                                                Voir
                                            </vs-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right flex flex-col">
                                    <small class="mt-1 whitespace-no-wrap">
                                        {{ ntf.time }}
                                    </small>
                                </div>
                            </div>
                        </li>
                    </ul>
                </component>

                <div class="
          checkout-footer
          fixed
          bottom-0
          rounded-b-lg
          text-primary
          w-full
          p-2
          font-semibold
          text-center
          border
          border-b-0
          border-l-0
          border-r-0
          border-solid
          d-theme-border-grey-light
          cursor-pointer"
                     @click="fullDisplay = !fullDisplay">
                    <span v-if="!fullDisplay">Afficher plus</span>
                    <span v-else>Afficher moins</span>
                </div>
            </vs-dropdown-menu>
        </vs-dropdown>

        <!-- New Message form -->
        <vs-prompt
            title="Créer un nouveau sujet"
            @cancel="clearSubjectForm"
            @accept="submitFormSubject"
            accept-text="Envoyer"
            cancel-text="Annuler"
            :is-valid="validMessage"
            :active.sync="activeModalMessage">
            <div class="message-form">

                <i class="far fa-info-circle mr-2"></i>Veuillez saisir votre message ci-dessous&nbsp;:

                <vs-input
                    type="text"
                    label="Sujet"
                    v-model="formSubject.title"
                    class="mt-4 mb-2 w-full"
                    :danger="!Boolean(formSubject.title)"
                    danger-text="Vous devez indiquer un titre"
                    placeholder="Sujet"
                    val-icon-pack="feather"
                    val-icon-danger="icon-x"
                />

                <vs-textarea label="Message (1000 caractères max.)" v-model="formSubject.message"
                             class="mt-4 mb-2 w-full" counter="1000" :counter-danger.sync="counterDanger"/>

                <vs-alert :active="!Boolean(formSubject.message)" color="danger">
                    <span class="text-sm">Vous devez saisir un message</span>
                </vs-alert>
            </div>
        </vs-prompt>
        <!-- ./New Message form -->
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import messageMixins from '@/libs/messageMixins'
import {mapState, mapActions} from 'vuex'

export default {
  mixins: [messageMixins],
  components: {
    VuePerfectScrollbar
  },
  computed: {
    ...mapState({
      subject: state => state.subject.subject,
      subjects: state => state.subject.subjects,
      subjectLoading: state => state.subject.subjectLoading,
      total: state => state.subject.total
    }),
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    notifications () {
      const subjectList = []
      let i = 0
      for (const subject of this.subjects) {
        subjectList.push({
          index: i++,
          id: subject.id,
          title: subject.title,
          lastMsg: subject.last_message,
          status: subject.status
        })
      }
      return subjectList
    },

    validMessage () {
      return Boolean(this.formSubject.title) && Boolean(this.formSubject.message) && !this.counterDanger
    }
  },
  data () {
    return {
      activeModalMessage: false,
      fullDisplay: false,
      counterDanger: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      formSubject: {
        title: '',
        message: ''
      }
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (to.name === 'Factures') {
      this.getAllSubjects({
        page: 1,
        limit: 100000
      }).then(() => {
        next()
      })
    } else {
      next()
    }
  },

  created () {
    this.refreshList()
  },

  methods: {
    ...mapActions('subject', ['getAllSubjects', 'addSubject']),

    refreshList () {
      this.getAllSubjects({
        page: 1,
        limit: 1000
      })
    },

    clearSubjectForm () {
      this.formSubject.title = ''
      this.formSubject.message = ''
    },

    submitFormSubject () {
      this.addSubject({
        date: this.$moment().format(),
        title: this.formSubject.title,
        message: this.formSubject.message
      }).then(() => {
        this.clearSubjectForm()
        this.refreshList()
      })
    },
    createSubject () {
      this.activeModalMessage = true
    }
  }
}
</script>

<style lang="scss">

.justify-content-between {
    justify-content: space-between;
}

.align-items-center {
    align-items: center;
}

.notification-dropdown {
    position: fixed;
    top: 71px !important;

    @media (min-width: 500px) {
        left: calc(100vw - 68px) !important;
    }

    @media (min-width: 576px) {
        left: calc(100vw - 48px) !important;
    }
    @media (min-width: 760px) {
        left: calc(100vw - 268px) !important;
    }
}

.folded {
    min-height: 248px;
    max-height: 248px;
}

.open {
    min-height: calc(var(--vh, 1vh) * 100 - 8rem - 62px);
    @media (min-width: 768px) {
        min-height: calc(var(--vh, 1vh) * 100 - 8rem - 92px);
    }
}
</style>
